import React from 'react'
import PropTypes from 'prop-types'
import { LogicGateSVG } from './LogicGateSymbol.style'

const ToggleLogicGate = (props) => (
  <LogicGateSVG width={40} height={32} viewBox="0 0 34 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <text
        fill="#FFF"
        fontFamily="Arial-BoldMT, Arial"
        fontSize={9}
        fontWeight="bold"
      >
        <tspan x={12.249} y={16}>
          {'XOR'}
        </tspan>
      </text>
      <rect
        width={26}
        height={26}
        x={8}
        fill="#687585"
        rx={4}
        className="selection"
      />
      <text
        fill="#FFF"
        fontFamily="Arial-BoldMT, Arial"
        fontSize={9}
        fontWeight="bold"
      >
        <tspan x={18.751} y={10}>
          {'T'}
        </tspan>
        <tspan x={18.25} y={22}>
          {'R'}
        </tspan>
      </text>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M15 12h12v1H15z"
        className="selection"
      />
      <path
        fill="#687585"
        d="M0 6.002h9v2H0zm0 12h9v2H0z"
        className="selection"
      />
    </g>
  </LogicGateSVG>
)

export default ToggleLogicGate

ToggleLogicGate.propTypes = {
  selected: PropTypes.bool,
}
